import { onBeforeMount, ref } from 'vue'
import useGQL from '@/composables/useGQL.js'
import { useStore } from '@/stores/main'

const pageStore = (pageSlug) => {
  const page = ref(null)
  const store = useStore()
  const { gqlQuery } = useGQL()

  const getPage = async (slug) => {
    if (!slug) return
    if (store.first_impression?.slug === slug) {
      page.value = store.first_impression
    } else {
      try {
        const data = await gqlQuery(`
          query getPagesACF {
            getPagesACF(
              slug: "${slug}"
            )
          }
          `)
        page.value = data?.data?.getPagesACF
      } catch (error) {
        console.error('error', error)
      }
    }
  }

  onBeforeMount(() => {
    getPage(pageSlug)
  })

  return {
    page,
  }
}

export default pageStore
